module.exports = __webpack_public_path__ + "img/insured.a3787378.png";